import { put, call } from 'redux-saga/effects';
import { showLoading, hideLoading } from '../../actions/Login/action';

import { DomainConverter } from '../../utils/common';
import request from '../../utils/request';
import { ActionType } from '../../schemas/App/App.Schema';
import { carrierDataSuccess } from '../../actions/manage/action';

export function* loadCarrierData(action: ActionType): any {
  const { query, isPullToRefresh, callback } = action.payload;
  try {
    yield put(showLoading(isPullToRefresh));
    const queryValue = DomainConverter.domainToData<any>(query);
    const response = yield call(request, [
      'MANAGE',
      'CARRIER_PROFILE',
      null,
      '',
      queryValue,
      'application/json'
    ]);
    const data =
      response.data && response.data.getCarrierProfile
        ? response.data.getCarrierProfile
        : [];
    yield put(carrierDataSuccess({ data }));
    yield put(hideLoading(isPullToRefresh));
  } catch (e) {
    if (callback) {
      callback();
    }
    yield put(hideLoading(isPullToRefresh));
  }
}
